import { render, staticRenderFns } from "./GlobalPermissions.vue?vue&type=template&id=3cfb8e82"
import script from "./GlobalPermissions.vue?vue&type=script&lang=js"
export * from "./GlobalPermissions.vue?vue&type=script&lang=js"
import style0 from "./GlobalPermissions.vue?vue&type=style&index=0&id=3cfb8e82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports